import React from 'react';
import Button from '@mui/material/Button'
function DeleteUser() {
  return <div>
      <Button>Delete user</Button>
  </div>;
}

export default DeleteUser;
